module.exports = ".mat-tab-body-content {\n    overflow-y: hidden;\n    overflow-x: scroll;\n}\n"